import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Services from "@/sections/Services";
import Manifesto from "@/sections/Manifesto";
import Pricing from "@/sections/Pricing";
import Offers from "@/sections/Offers";
import Booking from "@/sections/Booking";
import Contact from "@/sections/Contact";

const Landing = () => {
  const scrollToBook = () => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="landing-page">
      <Header onBook={scrollToBook} />
      <Hero onBook={scrollToBook} />
      <Marquee />
      <Services />
      <Offers onBook={scrollToBook} />
      <Manifesto />
      <Pricing />
      <Booking />
      <Contact />
      <Footer />
    </div>
  );
};

export default Landing;
